import { createApi } from "@reduxjs/toolkit/query/react";
import { extendedBaseQuery } from "../basequery"; // Import your basequery

export const pushNotificationApi = createApi({
    reducerPath: "pushNotificationApi",
    baseQuery: extendedBaseQuery, // Use the imported baseQuery function
    tagTypes: ["Push-Notification"],
    endpoints: (builder) => ({
        sendPushNotification: builder.mutation({
            query: (body) => ({
                url: "push-notification/fire-notification",
                method: "POST",
                body,   
            }),
            invalidatesTags: ["Push-Notification"],
        }),
    }),
});

export const {
    useSendPushNotificationMutation,
} = pushNotificationApi;